/**
 * Default word limit applied to AI tool text inputs (typed text, selected
 * lesson content and counted textareas). Fields can override it via their
 * config `wordLimit`.
 */
export const DEFAULT_WORD_LIMIT = 50000;
